import { Locale } from 'src/types'
import { TIME_IN_SECONDS } from 'src/constants'

import {
  Comparator,
  ListSorts,
  MaintenanceFilters,
  SortStates,
} from 'src/pages/ServiceMaintenanceHistory/types'

export const handleSortChange = (sortState: SortStates): Comparator => {
  switch (sortState) {
    case SortStates.BY_NEW:
      return (a, b) => {
        return (
          new Date(b.date.seconds * TIME_IN_SECONDS.SECOND).getTime() -
          new Date(a.date.seconds * TIME_IN_SECONDS.SECOND).getTime()
        )
      }
    case SortStates.BY_ODOMETER:
      return (a, b) => {
        const odometerB = b.odometer
        const odometerA = a.odometer

        return odometerB - odometerA
      }

    case SortStates.BY_TOTAL_COST:
      return (a, b) => {
        const costB = b.serviceCost
        const costA = a.serviceCost

        return costB - costA
      }

    case SortStates.BY_DETAILS:
      return (a, b) => {
        const detailsA = a.details.length
        const detailsB = b.details.length

        return detailsB - detailsA
      }

    default:
      throw new Error(`Unsupported sort state: ${sortState}`)
  }
}

export const getListOfSortsStates = (
  locale: Locale['maintenance']['historyMaintenance'],
): ListSorts[] => {
  const { byOdometer, byNew, byTotalCost, byDetails } = locale.sortStates

  return [
    {
      type: SortStates.BY_NEW,
      title: byNew,
    },
    {
      type: SortStates.BY_ODOMETER,
      title: byOdometer,
    },
    {
      type: SortStates.BY_TOTAL_COST,
      title: byTotalCost,
    },
    {
      type: SortStates.BY_DETAILS,
      title: byDetails,
    },
  ]
}

export function getCountOfActiveFilters(filters: MaintenanceFilters): number {
  return (Object.keys(filters) as Array<keyof MaintenanceFilters>).reduce(
    (acc, key) => {
      return acc + (filters[key] ? 1 : 0)
    },
    0,
  )
}
